<template>
  	<div class="pb-5x " >
		<Navbar :officer="officer"  />
		<div class="container"> 
			<Alert :loading="fullLoading"/>
			<div class="bg-danger text-white text-center py-2" v-if="error!==''"><i class="pi pi-exclamation-triangle"></i> {{error}} </div>
			<div class="text-center py-3" v-if="loading">
					<div><i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i></div>
					<div>Loading...</div>
			</div>
			<div v-if="jobData.length === 0 && !loading"  class="alert alert-secondary">ไม่พบงานใหม่</div>
			<JobItem v-for="(job, index) in jobData" :key="index" :job="job" @job-click="acceptJob" @get-job="handleGetJob" />
			<GetjobModal :showModal="showModal" @close-modal="closeModal" :job_detail="job_detail"  @get-job="handleGetJob" />
		</div>
		<FooterMenu :activeTab="activeTab" @menu-click="tabChange"/>
  	</div>
</template>

<script>

import axios from 'axios'
import JobItem from '@/components/JobItem.vue'
import GetjobModal from '@/components/GetjobModal.vue'
import FooterMenu from '@/components/FooterMenu.vue'
import Navbar from '@/components/Navbar.vue'
import Alert from '@/components/Alert.vue'
// import { API } from '@/config.js'




export default {
	name: 'HomeView',
	components: {
		JobItem,
		GetjobModal,
		FooterMenu,
		Navbar,
		Alert
	},
	data () {
		return {
			loading : true,
			fullLoading: false,
			jobData : [],
			interval :null,
			error : '',
			showModal: false,
			job_detail: {},
			activeTab: 'home',
			officer: {},
			officer_id: localStorage.getItem('officer_id'),
		}
	},
	methods: {
		acceptJob(job_id) {
			this.fullLoading = true 
			console.log('Custom id:', job_id);
			this.getJobOne(job_id)
			this.job_detail = {}
			this.showModal = true
			
		},
		async fetchJobs (){
            try {
				let res = await axios.post('/api/calldatabypoint',{device_id:localStorage.getItem('device_id')})
				if(res.data.position != "OFF" && res.data.joblist != null){
					this.jobData = res.data.joblist
				}
				this.$set(this.officer, 'positionname', res.data.positionname);
				this.loading = false
			} catch (error) {
				console.log('Error: ',error)
				this.error = error.message
			}
		},
		async getJobOne (job_id) {
			this.fullLoading = true 
			try {
				let res = await axios.post('/api/calldataone',{ id:job_id ,officer_id:localStorage.getItem('officer_id')})
				if(res.data && res.data.cartype_id){
					this.job_detail = res.data
					console.log(this.job_detail);
				}else{
					this.job_detail = {}
					this.showModal = false
				}
				this.fullLoading = false 
				
			} catch (error) {
				console.log('Error: ',error)
				this.error = error.message
				this.fullLoading = false 
			}
		},
		async handleGetJob (job) {
			let Data = {
				officer_id: this.officer_id,
				table: 'call_data',
				data: {
					status_id: job.status_id
				},
				where: {
					id: job.job_id
				}

			}

			this.fullLoading = true 
			
			console.log('data:555 ',Data)
			try {
				let res = await axios.post('/api/updatestatus',Data)
				this.fullLoading = false 
				if (res.data.status == 'success') {
					this.showAlert('สำเร็จ','success','บันทึกรายยการสำเร็จ')
					this.getJobOne(job.job_id)
					
				} else if (res.data.error != '0') {
					this.showAlert(res.data.error,'error','ไม่สามารถทำรายการได้')
				}
				
			}catch (error) {
				console.log('Error: ',error)
				this.showAlert('ผิดพลาด','error',error.message)
				this.fullLoading = false 
			}
			setTimeout(() => {
				this.fullLoading = false 
			}, 1000);
		
		},
		logout () {
			localStorage.clear()
			this.$router.push('/login')
		},
		closeModal () {
			this.job_detail = {}
			this.showModal = false
		},
		tabChange(tab) {
            this.$router.push('/'+tab).catch(err => {
                if (err.name !== 'NavigationDuplicated') {
                    throw err;
                }
            });
        },
		showAlert(title,type,text='') {
            this.$swal.fire({
                title: title,
                text: text,
                icon: type,
                confirmButtonText: 'ตกลง',
            });
        },
	},
	created () {
		this.fetchJobs()
	},
	mounted () {
		console.log(this.$route.query.jobid);
		if (this.$route.query.jobid) {
			this.acceptJob(this.$route.query.jobid)
		}
		this.interval = setInterval(this.fetchJobs, 1000);
	},
	beforeDestroy() {
		clearInterval(this.interval) // ล้าง interval เมื่อออกจากหน้านี้
	}
		
}
</script>
